module.exports = __webpack_public_path__ + "static/media/iconfont.557e46d0.ttf";